import { Controller } from "@hotwired/stimulus"

// Controller for grammar correction button
// Handles correction request via Turbo and displays loading state
export default class extends Controller {
  static targets = ["button", "loader", "error", "errorMessage"]
  static values = {
    url: String,
    locale: String
  }

  connect() {
    // Find the trix editor content target
    this.contentElement = this.element.closest('[data-tabs-target="content"]')?.querySelector('trix-editor')
  }

  async correct(event) {
    event.preventDefault()

    if (!this.contentElement) {
      this.showError("Impossible de trouver le contenu à corriger")
      return
    }

    // Get current content from Trix editor
    const content = this.contentElement.value

    if (!content || content.trim() === "") {
      this.showError("Le contenu est vide")
      return
    }

    // Show loader, hide button and error
    this.showLoader()

    try {
      // Build form data
      const formData = new FormData()
      formData.append("content", content)
      formData.append("locale", this.localeValue || "fr")

      // Send request via fetch (Turbo Stream will handle the response)
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": this.csrfToken,
          "Accept": "text/vnd.turbo-stream.html"
        },
        body: formData
      })

      if (!response.ok) {
        throw new Error(`Erreur HTTP: ${response.status}`)
      }

      // Get the Turbo Stream response
      const html = await response.text()

      // Apply the Turbo Stream
      Turbo.renderStreamMessage(html)

      // Hide loader, show button
      this.hideLoader()

    } catch (error) {
      console.error("Grammar correction error:", error)
      this.showError(error.message || "Une erreur est survenue")
      this.hideLoader()
    }
  }

  showLoader() {
    this.buttonTarget.classList.add("hidden")
    this.loaderTarget.classList.remove("hidden")
    this.hideError()
  }

  hideLoader() {
    this.loaderTarget.classList.add("hidden")
    this.buttonTarget.classList.remove("hidden")
  }

  showError(message) {
    if (this.hasErrorMessageTarget) {
      this.errorMessageTarget.textContent = message
    }
    if (this.hasErrorTarget) {
      this.errorTarget.classList.remove("hidden")
    }
  }

  hideError() {
    if (this.hasErrorTarget) {
      this.errorTarget.classList.add("hidden")
    }
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content
  }
}
